import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { finleyAssertUnreachable } from '@finley-technologies/common';

import { ResolvedLoanFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';

// Types
interface LoanSettingsMenuProps {
  loan: ResolvedLoanFragmentGQLType;
}

const ActiveLoanSettingsMenu = ({ loan }: LoanSettingsMenuProps) => {
  return (
    <Menu>
      <MenuButton>
        <Icon icon="ellipsis-vertical" />
      </MenuButton>
      <MenuList
        backgroundColor="white"
        borderRadius="8px"
        borderWidth="1px"
        borderColor={colors.gray[100]}
        boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)"
      >
        {loan.edits.destination?.loanId ? (
          <MenuItem as={RouterLink} to={`/loans/${loan.id}/edit/review`}>
            Review Edit
          </MenuItem>
        ) : (
          <MenuItem
            as={RouterLink}
            to={`/loans/${loan.id}/edit`}
            icon={<Icon icon="edit" />}
          >
            Edit Loan
          </MenuItem>
        )}

        {loan.edits.source?.loanId && (
          <>
            <MenuDivider />
            <MenuItem
              as={RouterLink}
              to={`/loans/${loan.edits.source.loanId}`}
              icon={<Icon icon="send-backward" />}
              color={colors.gray[800]}
            >
              Last edited
              {/* TODO: @markhaghani, pipe through the last edit date */}
            </MenuItem>
          </>
        )}
      </MenuList>
    </Menu>
  );
};

export const LoanSettingsMenu = ({ loan }: LoanSettingsMenuProps) => {
  switch (loan.calculatedLoanStatus) {
    case 'initiated':
    case 'funded':
    case 'overdue':
      return <ActiveLoanSettingsMenu loan={loan} />;

    // Adjust these as needed based on available menu options
    case 'pending':
    case 'pendingEdit':
    case 'canceled':
    case 'canceledEdit':
    case 'overriddenFromEdit':
    case 'paid':
      return null;

    default:
      throw finleyAssertUnreachable(loan.calculatedLoanStatus);
  }
};
